import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//重写push，解决相同路由重复插入的错误
const VueRouterPush = Router.prototype.push 
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

const router = new Router({
    mode: 'history',
    routes: [

        //
        {
            path: '/',
            name: 'index',
            meta: {
                showHeader: true,
                showFooter: true,
                title: '米莫印品-国内高端个性照片书，微信书，洗照片，照片台历与相框画，照片墙定制平台',
                content:{
                    keywords: '照片书、请柬、明信片、婚纱照、儿童摄影',
                    description: '米莫印品是国内专业高端的照片书，照片冲印，微信书，微博书，个性DIY创意印品，相片墙定制及分享平台，提供宝宝成长册，同学聚会纪念册，艺术写真集，全家福照片书，婚纱照相册，个性明信片的定制和印刷，是送男女朋友最有创意的个性生日礼物，欢迎拼团、团购。米莫印品的前身叫membook照片书。'
                }
            },
            component: () => import('@/views/index/index.vue')
        },
        {
            path: '/detail/:pid',
            name: 'detail',
            meta: {
                showHeader: true,
                showFooter: true,
                title: '米莫印品-diy相册，照片书，微信书，晒相片，照片台历与照片相框定制',
                content:{
                    keywords: '照片书、请柬、明信片、婚纱照、儿童摄影',
                    description: '米莫印品是国内最专业的个性DIY创意印品定制及分享平台，提供照片冲印，微信书，微博书，亲宝宝书，宝宝成长日记，照片台历的定制和印刷，欢迎团购。'
                }
            },
            component: () => import('@/views/detail/index.vue')
        },

        //关于页
        {
            path: '/about',
            name: 'about',
            meta: {
                showHeader: true,
                showFooter: true,
                title: '米莫印品-专注于DIY相册、照片书、婚纱摄影、宝宝成长相册高端定制，致力提供各类DIY个性定制。',
                content:{
                    keywords: '照片书、请柬、明信片、婚纱照、儿童摄影',
                    description: '米莫印品是专业高端的个性DIY相册、照片书定制及分享平台，能够在线上传照片，进行个性定制。提供DIY相册、宝宝成长记录相册、毕业纪念册、婚纱摄影相册等的制作和印刷，欢迎团购。'
                }
            },
            component: () => import('@/views/about/index.vue')
        },
        //为什么有选择我们介绍页
        {
            path: '/whyus',
            name: 'whyus',
            meta: {
                showHeader: true,
                showFooter: true,
                title: '米莫印品-DIY相册，照片书，儿童摄影相册，婚礼摄影相册制作选哪家？',
                content:{
                    keywords: '照片书、请柬、明信片、婚纱照、儿童摄影',
                    description: '米莫印品是专业高端的个性DIY创意相册、照片书定制及分享平台，能够在线上传照片进行个性定制，支持手机APP编辑制作。提供DIY相册、宝宝成长记录相册，毕业纪念册，婚礼摄影相册，个人写真相册的制作和印刷，欢迎团购。'
                }
            },
            component: () => import('@/views/whyus/index.vue')
        },
        //评价页
        {
            path: '/comment',
            name: 'comment',
            meta: {
                showHeader: true,
                showFooter: true,
                title: '米莫印品-照片冲印、DIY相册制作、婚纱摄影相册、宝宝成长相册制作印刷效果怎么样？',
                content:{
                    keywords: '照片书、请柬、明信片、婚纱照、儿童摄影',
                    description: '米莫印品是专业的个性DIY创意相册定制、照片书定制及分享平台，能够在线上传照片，进行个性定制。超过80万人选择米莫印品，好评度高达99%，我们提供DIY相册、个人写真相册、宝宝成长记录相册等的制作定制，欢迎团购。'
                }
            },
            component: () => import('@/views/comment/index.vue')
        },

        //升级页面，由c站用户自行升级到微盟
        {
            path: '/upgrade',
            name: 'upgrade',
            meta: {
                showHeader: false,
                showFooter: false,
            },
            component: () => import('@/views/upgrade/index.vue'),
            children: [
                {
                    path: '',
                    name: 'upgrade-login',
                    meta: {
                        title: '米莫权益搬家',
                        headerTitle: '登录米莫账户',
                        logout: false,
                        backgroundColor: '#f5f5f5',
                    },
                    component: () => import('@/views/upgrade/login/index.vue')
                },
                {
                    path: 'rights',
                    name: 'upgrade-rights',
                    meta: {
                        title: '米莫权益搬家',
                        headerTitle: '权益搬家',
                        logout: true,
                        backgroundColor: '#ffffff',
                    },
                    component: () => import('@/views/upgrade/rights/index.vue')
                },
                {
                    path: 'binding',
                    name: 'upgrade-binding',
                    meta: {
                        title: '米莫权益搬家',
                        headerTitle: '绑定账号',
                        logout: false,
                        backgroundColor: '#fff',
                    },
                    component: () => import('@/views/upgrade/binding/index.vue')
                },

            ]
        },
        
        //404重定向
        {
            path: "*",
            redirect: "/"
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        return savedPosition ?savedPosition :{ x: 0, y: 0 }
    }
})

/**
 * 路由钩子
 */
router.beforeEach((to, from,next) => {
    if(to.meta.title) {
        to.meta && to.meta.title && (document.title = to.meta.title)
    }
    if(to.meta.content) {
        let head = document.getElementsByTagName('head')
        head[0].querySelector('meta[name="Keywords"]').setAttribute('content', to.meta.content.keywords)
        head[0].querySelector('meta[name="Description"]').setAttribute('content', to.meta.content.description)
    }
    next()
})

export default router
